/* eslint-disable max-len */
export const getLeadProviders = (state) => state.leads.providers;
export const getLeadProvidersPending = (state) => state.leads.providersPending;
export const getLeadProvider = (state) => state.leads.provider;

export const getLeadMappings = (state) => state.leads.mappings;
export const getLeadMappingsPending = (state) => state.leads.mappingsPending;

export const getLeadAliases = (state) => state.leads.aliases;
export const getLeadAliasesPending = (state) => state.leads.aliasesPending;

export const getLeadMailboxes = (state) => state.leads.mailboxes;
export const getLeadMailboxesPending = (state) => state.leads.mailboxesPending;
export const getLeadMailboxMessages = (state) => state.leads.mailboxMessages;
export const getLeadMailboxMessagesPending = (state) => state.leads.mailboxMessagesPending;

export const getLeadSubscriptions = (state) => state.leads.subscriptions;

export const getLeadProcessed = (state) => state.leads.processed;
export const getLeadProcessedPending = (state) => state.leads.processedPending;
